import React, { useContext, useState } from 'react';
import { Row, Col, Card} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import Message from '../../../../Common/Message';
import { addFishboneToGAPBusinessElement } from '../../../../../services/sKPI/gap.service';
import { useGetFishboneTemplateList } from '../../../../../hooks/services/sKPI/useOfGAP';
import { _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';
import FishboneMiniToPanel from '../Fishbone/FishboneMiniToPanel';
import { ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import GapAppContext from '../../../../../GapAppContext';

const SidePanelFishboneSelection = (props) => {
    const { t } = useTranslation();
    const contextGap = useContext(GapAppContext);

    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_GAPId = props.gapId;
    const inputParam_ElementId = props.elementId;
    const inputParam_SetterGAPElements = props.setterGAPElements;
    

    const [selectedFishboneId, setSelectedFishboneId] = useState(null);
    const [fishboneList, setFishboneList] = useState(null);
    useGetFishboneTemplateList(fishboneList, setFishboneList, inputParam_IsPanelOpen)
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [isInvalidForm, setIsInvalidForm] = useState(false);

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        setShowMessage(false);
        setIsInvalidForm(false);
    };

    const onSelectFishbone = () => {
        const isValidForm = selectedFishboneId !== null;
        if (isValidForm) {
            addFishboneToGAPBusinessElement(inputParam_GAPId, inputParam_ElementId, selectedFishboneId).then((response) => {
                inputParam_SetterGAPElements && inputParam_SetterGAPElements(null);

                setFishboneList(null);
                setSelectedFishboneId(null);
                setIsInvalidForm(false)

                contextGap.dataserieFullData.set && contextGap.dataserieFullData.set(prevState => ({
                    ...prevState,
                    revisionDataserieFullList: null,
                    gapFishboneList: null             
                }))

                onDismissPanel();
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        }
        else {
            setShowMessage(true);
            setMessageType("warning");
            setIsInvalidForm(true)
            setMessage(t('data-lang-msg-requiredpartys'))
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
        setSelectedFishboneId(null);
    };
    
    const onClosePanel = () => {
        setFishboneList(null);
        onDismissPanel();
    };

    const onChangeSelectedFishbone = (fishboneId) => {
        setSelectedFishboneId(fishboneId)
    };
    
    const recurrentCheckItems = (items, currentNode) => {
        items.forEach(x => {
            if (x.children !== undefined && x.children !== null && x.children.length > 0) {
                x.children = recurrentCheckItems(x.children, currentNode);
            }

            if (x.id === currentNode.id) {
                x.checked = currentNode.checked;
            }
        })

        return items;
    };

    const onRenderFooterContent = () => {
        return <div>
            <PrimaryButton onClick={ onSelectFishbone } styles={_global_buttonStyles}>{ t('data-lang-btn-select') }</PrimaryButton>
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-selectfishbone') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth="900px"
                type={ PanelType.custom }
            >
                <ScrollablePane className='mt-5 mb-5' scrollbarVisibility={ScrollbarVisibility.auto}>
                    {
                        fishboneList && fishboneList.map((fishbone, index) => (
                            <Card key={index} className={`ps-3 pe-3 m-3 cursor-pointer${selectedFishboneId === fishbone.id ? " fishbone-panel-selected" : ""}`} onClick={() => onChangeSelectedFishbone(fishbone.id)}>
                                {
                                    selectedFishboneId === fishbone.id &&
                                    <>
                                        <div className='fishbone-selected-icon-wildcard-content'></div>
                                        <i className="ms-Icon ms-Icon--SkypeCircleCheck fishbone-selected-icon" aria-hidden="true"></i>
                                    </>
                                }
                                <FishboneMiniToPanel inputParam_FishboneData={fishbone} />
                            </Card>
                        ))
                    }
                </ScrollablePane>
                <Row className="pt-3 mx-auto">
                    <Col className="message-verybottom-panel-medium">
                        <Message width="96%" message={ message } display={ showMessage === null? false : showMessage } messageType={messageType} setterShowMessage={ setShowMessage } />
                    </Col>
                </Row>  
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelFishboneSelection;